import { IPlayer } from '../types/IPlayerDocument';

export default function getAvatar(player: IPlayer) {
  return (
    player.avatar ||
    `https://avatars.dicebear.com/v2/jdenticon/${player.name}.svg?options[background]=%23FFFFFF`
  );
}
